// export const generateConnection = (obj1, obj2) => {
//   const obj1ByObj2 = {}

//   for (const key2 in obj2) {
//     const value1 = obj1[key2]

//     if (value1 !== undefined) {
//       obj1ByObj2[obj2[key2]] = value1 || ''
//     }
//   }

//   return Object.freeze(obj1ByObj2)
// }

export const defineAbbr = text => {
  if (!text) return ''
  // Split by spaces, filter out empty, take first char of each word
  const abbr = text
    .split(/\s+/)
    .filter(Boolean)
    .map(word => word[0])
    .join('')
    .toUpperCase()
    .slice(0, 2)
  return abbr
}

export const defineStarsByScore = (score, max) => {
  const scorePercentage = (score / max) * 100

  if (scorePercentage === 0) return 0
  if (scorePercentage < 49) return 1
  if (scorePercentage < 100) return 2

  return 3
}

/**
 * Detects if the current browser is an embedded/in-app browser (e.g. LinkedIn, Facebook, Instagram, etc.)
 * Returns true if detected, false otherwise.
 */
export function isEmbeddedBrowser() {
  const ua = navigator.userAgent || navigator.vendor || window.opera
  // Common in-app/embedded browser signatures
  const patterns = [
    /FBAN|FBAV/i, // Facebook
    /Instagram/i, // Instagram
    /Line\//i, // LINE
    /LinkedInApp/i, // LinkedIn
    /Twitter/i, // Twitter
    /Snapchat/i, // Snapchat
    /TikTok/i, // TikTok
    /Pinterest/i, // Pinterest
    /Messenger/i, // Facebook Messenger
    /WhatsApp/i, // WhatsApp
    /WeChat/i, // WeChat
    /MiuiBrowser/i, // Xiaomi
    /SamsungBrowser/i, // Samsung
    /wv\b/i // Android WebView
  ]
  return patterns.some(pattern => pattern.test(ua))
}
